/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/20/19
 * Time: 11:59 AM
 */

import React, {Component} from 'react';
import WelcomeImg from '../../../assets/img/login.png'
import './Home.css'

class App extends Component {
  render() {
    return (
      <div className={"recept-home"}>
        <h1><span className={"welcome-note-home"}>Welcome back to </span><span
          className={"welcome-text-home logo-text"}>Visitor <span style={{color: '#53bd52'}}>#</span>tags</span></h1>
        <img className={"animated zoomIn"} src={WelcomeImg}
             style={{width: '30%', height: '180%', objectFit: 'contain'}} alt={"."}/>
      </div>
    );
  }
}

export default App;
